import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
// services
import { MessageService } from '../../../../services/message.service'
import { MasterService } from '../../../../services/master.service'
import { StoreService } from '../../../../services/store.service'
import * as languageLibrary from '../../../../services/language'
import moment from 'moment';


@Component({
    selector: 'inventory-history',
    templateUrl: './inventory-history.component.html',
    styleUrls: ['./inventory-history.component.scss'],
    standalone: false
})
export class InventoryHistoryComponent implements OnInit {
    /*
    * Variables
    */
    //
    @Output() emitterInformation$: EventEmitter<Object> = new EventEmitter()
    // save the language
    @Input() language: string = 'EN'
    @Input() lotId: number;
    @Input() statusId: number;
    @Input() dateOnLot: Date;
    @Input() inventoryId: number = 0
    // set all words
    protected words = languageLibrary.language
    protected inventoryStatuses: any[];   //selectable
    protected statusHistoryList: any[];
    // define the inventory id
    protected loading: boolean = false
    protected statusInformation = new FormGroup({
        statusId: new FormControl<number | null>(null, Validators.required),
        startDate: new FormControl<string>(moment().format('YYYY-MM-DD'), Validators.required,),
        endDate: new FormControl<string | null>(null),
        inventoryId: new FormControl<number | null>(null, Validators.required),
        id: new FormControl<number | null>(null),
    },
        {
            validators: Validators.compose([this.dateInPast('startDate')])
        })

    /*
    * life cycles
    */
    constructor(private router: Router, private route: ActivatedRoute, private ms: MessageService, private master: MasterService, private store: StoreService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
        //Add '${implements OnChanges}' to the class.
        const identity = this.inventoryId
        if (isNaN(identity) || identity == 0) {
            return
        }
        this.getInventoryHistory()
    }

    ngOnInit() {
        this.getInventoryStatuses()
        const identity = this.inventoryId
        if (isNaN(identity) || identity == 0) {
            return
        }

        this.statusInformation.get('inventoryId').setValue(this.inventoryId)
        this.getInventoryHistory()

    }

    public saveStatus() {
        if (!this.inventoryId || isNaN(this.inventoryId) || (this.inventoryId <= 0)) {
            return
        }

        const id = this.statusInformation.get('id').value
        if (!id || isNaN(id) || (id <= 0)) {
            this.createStatus()
            return
        }

        this.modifyStatus()
    }

    public createStatus() {
        this.statusInformation.get('inventoryId').setValue(this.inventoryId)
        if (this.statusInformation.invalid) {
            return
        }

        this.master.post(`inventory/${this.inventoryId}/status`, { information: this.statusInformation.value }, (res) => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.statusHistoryList = res.data.statusHistory
            this.emitterInformation$.emit({ message: 'showNewStatusId', statusId: res.data.statusId })
        })
    }
    public selectStatus(statusHistoryData) {
        (document.getElementById('save-btn').innerHTML = 'Update')
        this.statusInformation.setValue({
            statusId: statusHistoryData.statusId,
            startDate: statusHistoryData.startDate,
            endDate: statusHistoryData.endDate,
            inventoryId: statusHistoryData.inventoryId,
            id: statusHistoryData.id
        })
    }

    public modifyStatus() {
        if (this.statusInformation.invalid) {
            return
        }

        let id = this.statusInformation.get('id').value

        this.master.put(`inventory/${this.inventoryId}/status/${id}`, { information: this.statusInformation.value }, (res) => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.statusHistoryList = res.data.statusHistory
            this.emitterInformation$.emit({ message: 'showNewStatusId', statusId: res.data.statusId })
            this.resetStatusInformationForm()
        })
    }

    public resetStatusInformationForm() {
        this.statusInformation.reset();
        this.statusInformation.get("inventoryId").setValue(this.inventoryId);
        (document.getElementById('save-btn').innerHTML = 'Save')
    }

    public deleteStatus(id) {
        if (this.statusInformation.get('statusId').value === 5 || this.statusHistoryList.length == 1) {
            return
        }

        this.master.discard(`inventory/${this.inventoryId}/status/${id}`, (res) => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.statusHistoryList = res.data.statusHistory
            this.emitterInformation$.emit({ message: 'showNewStatusId', statusId: res.data.statusId })
        })
    }
    public calculateDaysDiff = (startDateVar: Date, endDateVar: Date) => {
        if (!startDateVar) {
            return null
        }
        let startDate = moment(startDateVar);
        let endDate = endDateVar ? moment(endDateVar) : null
        if (!endDate) {
            let now = moment(moment().format('YYYY-MM-DD'))
            let daysDiff = now.diff(startDate, 'days')
            if (daysDiff === 0) {
                return 'today'
            }
            return daysDiff + ' day(s)'
        }
        return `${endDate.diff(startDate, 'days')} day(s)`
    }

    public getInventoryStatuses() {
        this.master.get(`collections/inventory/statuses?selectable=true`, (res) => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.inventoryStatuses = res.data.inventoryStatuses
        })
    }


    public getInventoryHistory() {
        if (!this.inventoryId || (this.inventoryId <= 0)) {
            return
        }

        this.master.get(`inventory/${this.inventoryId}/statusHistory`, (res) => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.statusHistoryList = res.data.inventoryStatusHistory
        })
    }

    public dateInPast(startDate: string) {
        return (group: FormGroup): { [key: string]: any } => {
            let start = group.controls[startDate]
            
            if (moment().startOf('day').isBefore(start.value)) {
                return {
                    dates: "Start date from should be in the past"
                };
            } 

            if (start.value < this.dateOnLot) {
                return {
                    dates: "Start date cannot be before the date on lot."
                };
            }

            return null
        }
    }
}


